<template>
	<div id="non-exportable-tool-modal" class="modal-new hidden">
		<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Non-exportable tool</span>

		<p class="description" style="text-align: left">
			The tool you have added cannot be exported as a LUT. While you may apply the effect of the tool to a graded version of your image,
			please note that when you export a LUT the tool and its effect will be excluded from export.
		</p>

		<div class="buttons-continer --single-item">
			<button @click="onConfirm" type="button" class="modal-btn --primary">I understand</button>
		</div>

		<div class="option-container">
			<div class="switch switch-container">
				<input type="checkbox" v-model="doNotShow" name="do-not-show" />
				<span class="slider round"></span>
			</div>
			<span class="option-title">Do not show this message again</span>
		</div>
	</div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
	data() {
		return {
			doNotShow: false,
		};
	},
	methods: {
		onConfirm() {
			if (this.doNotShow) {
				Cookies.set("acceptedNonExportableTool", true);
			}

			window.UI.hideModal();
		},
	},
};
</script>

<style lang="scss" scoped>
.option-container {
	margin-top: 34px;
	> .switch {
		margin-left: initial;
	}
}
</style>
